module.exports = __webpack_public_path__ + "3639ecfe65c1c82c5169dac4ae826b47.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/galeriaFotos/resplendor3.jpg
// module id = 71
// module chunks = 0